import React from 'react';
import { SvgIcon, useTheme } from '@material-ui/core';

export default function AlertCircle(props) {
  const { palette } = useTheme();
  const strokeColor = palette.scoreTier[3];
  return (
    <SvgIcon height="40" width="40" viewBox="0 0 40 40" {...props}>
      <>
        <path
          d="M20.0002 36.6667C29.2049 36.6667 36.6668 29.2048 36.6668 20C36.6668 10.7953 29.2049 3.33334 20.0002 3.33334C10.7954 3.33334 3.3335 10.7953 3.3335 20C3.3335 29.2048 10.7954 36.6667 20.0002 36.6667Z"
          fill="none"
          stroke={strokeColor}
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 13.3333V20.8333"
          fill="none"
          stroke={strokeColor}
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 26.6472V26.6638"
          fill="none"
          stroke="#A94746"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    </SvgIcon>
  );
}
